// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"BaseLayout_mainContent__JV_p0","isStaging":"BaseLayout_isStaging__lKZYE","hasFooter":"BaseLayout_hasFooter__vQ9nt"};